<template>
    <div>
        <img class="img" :src="`https://images.weserv.nl/?dpr=1&w=200&il&url=https://cdn.jsdelivr.net/gh/PokeMiners/pogo_assets/Images/Pokemon/Addressable%20Assets/pm${templateArgs.data.dex.split(',')[templateArgs.data.dex.split(',').length-1]}.icon.png`"  @error="placeholder" />
    </div>
</template>

<script>
export default {
    name: 'templateImages',
    data: () => ({
        templateArgs: {}
    }),
    computed: {
        imgDefault() {
            return require('../assets/sem-imagem.jpg')
        }
    },
    methods: {
        placeholder(e) {
            return  e.target.src = 'https://images.weserv.nl/?dpr=1&w=200&il&url=https://cdn.jsdelivr.net/gh/PokeMiners/pogo_assets/Images/Menu%20Icons/ic_pikachu_home.png'
        },
    },
}
</script>

<style lang="scss" scoped>
.img {
    max-height: 70px;
    //object-fit: cover;
}
</style>